import React from 'react';

import Helmet from 'common/helmets/Helmet';
import AdminSettingsHeader from 'common/subdomain/admin/AdminSettings/AdminSettingsHeader';
import AdminSettingsSidebarLink from 'common/subdomain/admin/AdminSettingsSidebarLink';
import { RoutePermissions } from 'common/util/permissions';

import 'css/components/subdomain/admin/_AdminGeneralSettingsContainer.scss';

type GeneralSidebarLink = {
  label: string;
  urlSuffix: keyof typeof RoutePermissions.adminSettings.general;
};

const SidebarLinks: GeneralSidebarLink[] = [
  {
    label: 'Branding',
    urlSuffix: 'branding',
  },
  {
    label: 'Preferences',
    urlSuffix: 'preferences',
  },
  {
    label: 'Delete',
    urlSuffix: 'delete',
  },
];

const AdminGeneralSettingsContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="adminGeneralSettingsContainer">
      <Helmet title="General settings | Canny" />
      <AdminSettingsHeader title="General" subheading="Manage your workspace's&nbsp;settings." />
      <div className="settingsContainer">
        <div className="settingsSidebar">
          {SidebarLinks.map(({ label, urlSuffix }) => {
            return (
              <AdminSettingsSidebarLink
                key={urlSuffix}
                requiredPermissions={RoutePermissions.adminSettings.general[urlSuffix]}
                to={`/admin/settings/company/${urlSuffix}`}>
                {label}
              </AdminSettingsSidebarLink>
            );
          })}
        </div>
        <div className="settingsContent">{children}</div>
      </div>
    </div>
  );
};

export default AdminGeneralSettingsContainer;
